import { render, staticRenderFns } from "./PartnerReachedModal.vue?vue&type=template&id=ec55d1a4"
import script from "./PartnerReachedModal.vue?vue&type=script&lang=js"
export * from "./PartnerReachedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports